import Shreepati from "../Img/Shreepati-Group-Reaching.jpg";
import Runwal from "../Img/Runwal-Logo.jpg";
import WebsiteForm from "./WebsiteForm";
import RunwalShow from "../Img/Runwal-Show.png";
import { Helmet } from "react-helmet";
export default function Dubai() {
  return (
    <>
      <Helmet>
        <title>Mumbai Property Expo 2024 in Dubai</title>
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:title"
          content="Mumbai Property Expo 2024 in Dubai"
        />
        <meta
          property="og:description"
          content="You're Invited to Visit Mumbai's Finest Luxury Property Expo"
        />
        <meta
          property="og:url"
          content="https://propexpo.infairs.co.in/dubai"
        />
        <meta
          property="og:image"
          content="https://propexpo.infairs.co.in/static/media/banner.988f8e827a1ed68a0267.png"
        />
        <link rel="canonical" href="https://propexpo.infairs.co.in/dubai" />

        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-JZWYJEBX59"></script>
        <script>
          {`window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-JZWYJEBX59');`}
        </script>
      </Helmet>
      <section className="lead-genration-page">
        <div className="container-fluid">
          <div className="row mt-lg-5">
            <img src={RunwalShow} alt="Logo" className="img-fluid logo" />
            {/* <img src={Shreepati} alt="Logo" className="img-fluid logo-2" /> */}
            <div className="col-12 text-center color-theme mb-4 mb-lg-5">
              <h1 className="mb-0 ms-lg-5">
                You're Invited to Visit Mumbai's Finest Luxury Property Expo
              </h1>
            </div>
            <div className="col-lg-8">
              <div className="content">
                {/* <img src={RunwalShow} alt="Logo" className="img-fluid" /> */}
                <h2>CITY SEASONS TOWERS DUBAI</h2>
                <h5>
                  Sheikh Khalifa Bin Zayed Rd,
                  <br /> Next to Burjuman Mall،
                  <br /> Mankhool - Dubai - United Arab Emirates.
                </h5>
                <h3 className="mb-0 mt-3">26 & 27, October 2024.</h3>
                <h3>Sat - Sun from 11:00 am to 07:00 pm</h3>
              </div>
            </div>
            <div className="col-md-8 col-lg-4">
              <WebsiteForm />
            </div>
            <div className="col-12">
              <p className="text-white mt-5">
                Artist's Impression | T&C Apply | All Projects are RERA
                Approved.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
